import AdminModel from './AdminModal'

var API = new AdminModel()
export default API
